import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import PageSchema from './components/PageSchema';
import PageCanonical from './components/PageCanonical';
import HomePage from './pages/HomePage';
import Courses from './pages/Courses';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Post from "./pages/Post";
import Coursessingle from "./pages/Coursessingle";
import Thankyou from "./pages/Thankyou";
import Aboutus from "./pages/Aboutus";
import Product from "./pages/Product";
import Productinternal from "./pages/Productinternal";
import DesignStudio from "./pages/DesignStudio";
import Project from "./pages/Project";
import Harmonyinternal from "./pages/Harmonyinternal";
import SuccessPage from "./pages/SuccessPage";
import Oneonone from "./pages/Oneonone";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";



const App = () => {
  return (
    <div> 
      <Header />
      <PageSchema />
      <PageCanonical />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/product" element={<Product />} />
        <Route
          path="/uniform-manufacturer/corporate-admin"
          element={<Navigate to="/uniform-manufacturer/pilot-uniforms-aviation" replace />}
        />
        <Route path="/uniform-manufacturer/:slug" element={<Productinternal />} />
        <Route path="/design-studio" element={<DesignStudio />} />
        <Route path="/project" element={<Project />} />
        <Route path="/ambience-and-harmony" element={<Harmonyinternal />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog/:slug" element={<Post />} />
        <Route path="/courses/:id" element={<Coursessingle />} /> 
        <Route path="/thank-you" element={<Thankyou />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/one-on-one-transformation" element={<Oneonone />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
};



export default App;
